module.exports = __webpack_public_path__ + "static/media/icon-company-active.29db8411.svg";